import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class UrlUtils {
    urlRegex = /(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .#&?%\-=]*)\/?/;
}
